import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import PIMRNEdit from './PumpSpareInternational/Edit';
import MRNMDEdit from './ManufacturingDomestic/Edit';

function MRNEdit() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [mrntype, setmrntype] = useState('');
  const [mrncategory, setmrncategory] = useState('');
  const [mrnData, setMrnData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}materialReceiptNote/findById/${id}`, {
          headers: authHeader(),
        });
        setMrnData(response.data);
        setmrntype(response.data.mrntype);
        setmrncategory(response.data.mrncategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (mrntype === 'Pump Spare' && mrncategory === 'International') {
      return <PIMRNEdit />;
    } else if (mrntype === 'Manufacturing') {
      return <MRNMDEdit />;
    }
    return null;
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}materialReceiptNote/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/mrnindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPDATE GRN</h6>
          <div className="view-buttons">
            <Link to={`/mrnindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={mrntype} onChange={(e) => setmrntype(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select disabled value={mrncategory} onChange={(e) => setmrncategory(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default MRNEdit;
